<template>
  <div class="body">
    <div class="head-banner"></div>
    <div
      class="warning"
      v-show="$route.query.type"
    >
      <i class="el-icon-warning-outline"></i>
      <p>
        抱歉，您的信息审核不通过，失败原因：{{
          formData.airFailReason || formData.travelFailReason
        }}
      </p>
    </div>
    <div class="content">
      <div class="form-data-info">
        <div class="form-data-head">账号信息</div>
        <div class="form-data-input">
          <el-form
            label-width="150px"
            :model="formData"
            :rules="rules"
            ref="userForm"
            status-icon
          >
            <el-form-item
              label="账号类型:"
              prop="buyerType"
            >
              <el-radio-group
                v-model="formData.applicationType"
                :disabled="$route.query.type ? true : false"
              >
                <el-radio :label="'1'">机票（代理人）</el-radio>
                <el-radio :label="'2'">旅游（旅行社）</el-radio>
                <el-radio :label="'1+2'">机票+旅游（代理人+旅行社）</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="账号:"
              prop="userName"
            >
              <el-input
                v-model="formData.userName"
                placeholder="请输入账号"
                @blur="queryUserName"
                maxlength="20"
                :disabled="$route.query.type ? true : false"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="密码:"
              prop="password"
            >
              <el-input
                v-model="formData.password"
                type="password"
                placeholder="请输入密码"
                autocomplete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="确认密码:"
              prop="passwordAgain"
            >
              <el-input
                v-model="formData.passwordAgain"
                type="password"
                placeholder="请再次输入密码"
                autocomplete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号:"
              prop="phone"
            >
              <div class="flex-center-start">
                <el-input
                  v-model="formData.phone"
                  placeholder="请输入手机号"
                ></el-input>
                <el-button
                  class="code-btn flex-center"
                  :loading="getCodePhone.statu"
                  @click="getNote"
                  :disabled="getCodePhone.show"
                >
                  <span v-show="getCodePhone.show">{{ getCodePhone.num }}秒</span>
                  {{ getCodePhone.text }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
              label="短信验证码:"
              prop="smsCode"
            >
              <el-input
                v-model="formData.smsCode"
                placeholder="请输入短信验证码"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="form-data-head">企业信息</div>
        <div class="form-data-input">
          <el-form
            label-width="170px"
            :model="formData"
            :rules="rules"
            ref="companyForm"
          >
            <el-form-item
              label="公司名称:"
              prop="companyName"
            >
              <el-input
                v-model="formData.companyName"
                placeholder="请输入公司名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="所属城市:"
              prop="areaCitys"
            >
              <el-col :span="8">
                <el-select
                  v-model="formData.areaRegions"
                  placeholder="请选择大区"
                  @change="_getArea"
                >
                  <el-option
                    v-for="item in siteList.area"
                    :key="item.id"
                    :label="item.areaName"
                    :value="[item.id, item.areaName]"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col
                :span="8"
                style="padding: 0 10px"
              >
                <el-select
                  v-model="formData.areaProvinces"
                  placeholder="请选择省份"
                  @change="_getProvince"
                >
                  <el-option
                    v-for="item in siteList.province"
                    :key="item.id"
                    :label="item.areaName"
                    :value="[item.id, item.areaName]"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="formData.areaCitys"
                  placeholder="请选择城市"
                >
                  <el-option
                    v-for="item in siteList.city"
                    :key="item.id"
                    :label="item.areaName"
                    :value="[item.id, item.areaName]"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item
              label="公司地址:"
              prop="companyAddress"
            >
              <el-input
                v-model="formData.companyAddress"
                placeholder="请输入公司地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="传真:">
              <!-- <div style="width:100px;display:inline-block">
                                 <el-input v-model="formData.type" placeholder="区号"></el-input>
              </div>-->
              <div style="width: 200px; display: inline-block">
                <el-input
                  v-model="formData.financeFax"
                  placeholder="传真号"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              label="统一社会信用代码:"
              prop="businessLicenseNum"
            >
              <el-input
                v-model="formData.businessLicenseNum"
                placeholder="请输入统一社会信用代码"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="统一社会信用代码图片:"
              prop="businessLicensePic"
            >
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :before-upload="detectionImg"
                :http-request="(res) => uploadChange(res, 'businessLicensePic', 'companyForm')"
                :file-list="fileListImg['businessLicensePic']"
                accept="image/jpg, image/jpeg, image/x-png"
                v-loading="uploadLoading['businessLicensePic']"
              >
                <img
                  v-if="imageUrl['businessLicensePic']"
                  :src="imageUrl['businessLicensePic']"
                  class="avatar"
                >
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="法人身份证号码:">
              <el-input
                v-model="formData.idCard"
                placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人代表身份证:">
              <div class="form-item-card">
                <p class="form-item-card-title">请上传身份证(正面)</p>
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :before-upload="detectionImg"
                  :http-request="(res) => uploadChange(res, 'idCardFront', 'companyForm')"
                  :file-list="fileListImg['idCardFront']"
                  accept="image/jpg, image/jpeg, image/x-png"
                  v-loading="uploadLoading['idCardFront']"
                >
                  <img
                    v-if="imageUrl['idCardFront']"
                    :src="imageUrl['idCardFront']"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  ></i>
                </el-upload>
              </div>
              <div class="form-item-card">
                <p class="form-item-card-title">请上传身份证(反面)</p>
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :before-upload="detectionImg"
                  :http-request="(res) => uploadChange(res, 'idCardReverse', 'companyForm')"
                  :file-list="fileListImg['idCardReverse']"
                  accept="image/jpg, image/jpeg, image/x-png"
                  v-loading="uploadLoading['idCardReverse']"
                >
                  <img
                    v-if="imageUrl['idCardReverse']"
                    :src="imageUrl['idCardReverse']"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  ></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <el-col v-show="
            formData.applicationType == '1' || formData.applicationType == '1+2'
          ">
          <div class="form-data-head">机票联系人</div>
          <div class="form-data-input">
            <el-form
              label-width="150px"
              :model="formData"
              :rules="rules"
              ref="airUserForm"
            >
              <el-form-item
                label="联系人:"
                prop="airLinkman"
              >
                <el-input
                  v-model="formData.airLinkman"
                  placeholder="请输入联系人"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="手机号:"
                prop="airPhone"
              >
                <el-input
                  v-model="formData.airPhone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱:">
                <el-input
                  v-model="formData.airEmail"
                  placeholder="请输入电子邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人QQ:">
                <el-input
                  v-model="formData.airQq"
                  placeholder="请输入联系人QQ"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-data-head">机票资质</div>
          <div class="form-data-input">
            <el-form
              label-width="150px"
              :model="formData"
              :rules="rules"
              ref="airForm"
            >
              <el-form-item
                label="OfficeID:"
                prop="officeId"
              >
                <el-input
                  v-model="formData.officeId"
                  placeholder="请输入OfficeID"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="国内出票时间:"
                prop="domesticWorkday"
              >
                <el-col class="ticket-time">
                  <span>周一至周五</span>
                  <!-- <el-time-picker
                                is-range
                                format="HH:mm:ss"
                                v-model="formData.domesticWorkday"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                placeholder="选择时间范围">
                  </el-time-picker>-->
                  <el-time-picker
                    v-model="formData.domesticWorkday[0]"
                    placeholder="开始时间"
                    value-format="HH:mm:SS"
                  ></el-time-picker>
                  <el-time-picker
                    v-model="formData.domesticWorkday[1]"
                    placeholder="结束时间"
                    value-format="HH:mm:SS"
                  ></el-time-picker>
                </el-col>
                <el-col class="ticket-time">
                  <span>周六至周日</span>
                  <!-- <el-time-picker
                                is-range
                                v-model="formData.domesticWorkWeek"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                placeholder="选择时间范围">
                  </el-time-picker>-->
                  <el-time-picker
                    v-model="formData.domesticWorkWeek[0]"
                    placeholder="开始时间"
                    value-format="HH:mm:SS"
                  ></el-time-picker>
                  <el-time-picker
                    v-model="formData.domesticWorkWeek[1]"
                    placeholder="结束时间"
                    value-format="HH:mm:SS"
                  ></el-time-picker>
                </el-col>
              </el-form-item>
              <el-form-item
                label="国际出票时间:"
                prop="internationalWorkday"
              >
                <el-col class="ticket-time">
                  <span>周一至周五</span>
                  <!-- <el-time-picker
                                is-range
                                v-model="formData.internationalWorkday"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                placeholder="选择时间范围">
                  </el-time-picker>-->
                  <el-time-picker
                    v-model="formData.internationalWorkday[0]"
                    placeholder="开始时间"
                    value-format="HH:mm:SS"
                  ></el-time-picker>
                  <el-time-picker
                    v-model="formData.internationalWorkday[1]"
                    placeholder="结束时间"
                    value-format="HH:mm:SS"
                  ></el-time-picker>
                </el-col>
                <el-col class="ticket-time">
                  <span>周六至周日</span>
                  <!-- <el-time-picker
                                is-range
                                default-value="00:00:00"
                                v-model="formData.internationalWeek"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                placeholder="选择时间范围">
                  </el-time-picker>-->
                  <el-time-picker
                    v-model="formData.internationalWeek[0]"
                    placeholder="开始时间"
                    value-format="HH:mm:SS"
                  ></el-time-picker>
                  <el-time-picker
                    v-model="formData.internationalWeek[1]"
                    placeholder="结束时间"
                    value-format="HH:mm:SS"
                  ></el-time-picker>
                </el-col>
              </el-form-item>
              <el-form-item
                label="CATA认可证书:"
                prop="cataProve"
              >
                <div class="form-item-card">
                  <p class="form-item-card-title">请上传CATA认可证</p>
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :show-file-list="false"
                    :before-upload="detectionImg"
                    :http-request="(res) => uploadChange(res, 'cataProve', 'airForm')"
                    :file-list="fileListImg['cataProve']"
                    accept="image/jpg, image/jpeg, image/x-png"
                    v-loading="uploadLoading['cataProve']"
                  >
                    <img
                      v-if="imageUrl['cataProve']"
                      :src="imageUrl['cataProve']"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    ></i>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="IATA认可证书:">
                <div class="form-item-card">
                  <p class="form-item-card-title">请上传IATA认可证</p>
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :show-file-list="false"
                    :before-upload="detectionImg"
                    :http-request="(res) => uploadChange(res, 'iataProve')"
                    :file-list="fileListImg['iataProve']"
                    accept="image/jpg, image/jpeg, image/x-png"
                    v-loading="uploadLoading['iataProve']"
                  >
                    <img
                      v-if="imageUrl['iataProve']"
                      :src="imageUrl['iataProve']"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    ></i>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                label="担保函:"
                prop="guarantee"
              >
                <div class="form-item-card">
                  <p class="form-item-card-title">请上传担保函</p>
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :show-file-list="false"
                    :before-upload="detectionImg"
                    :http-request="(res) => uploadChange(res, 'guarantee', 'airForm')"
                    :file-list="fileListImg['guarantee']"
                    accept="image/jpg, image/jpeg, image/x-png"
                    v-loading="uploadLoading['guarantee']"
                  >
                    <img
                      v-if="imageUrl['guarantee']"
                      :src="imageUrl['guarantee']"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    ></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-form>
            <div
              class="form-data-submit"
              v-show="formData.applicationType !== '1+2'"
            >
              <div class="form-data-sub-box">
                <div class="form-data-sub-text flex-center-start">
                  <el-checkbox v-model="agreeStatu"></el-checkbox>
                  <span>
                    我已同意
                    <span
                      class="cursor"
                      style="color: #237dc8"
                      @click="protocolText.show = true"
                    >《{{ protocolText.title }}》</span>
                    <span
                      class="cursor"
                      style="color: #237dc8"
                      @click="protocolText.show1 = true"
                    >《{{ protocolText.title1 }}》</span>
                  </span>
                </div>
                <el-button
                  type="primary"
                  @click="submitForm"
                >立即提交</el-button>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-show="
            formData.applicationType == '2' || formData.applicationType == '1+2'
          ">
          <div class="form-data-head">旅游联系人</div>
          <div class="form-data-input">
            <el-form
              label-width="150px"
              :model="formData"
              :rules="rules"
              ref="travelUserForm"
            >
              <el-form-item
                label="联系人:"
                prop="travelLinkman"
              >
                <el-input
                  v-model="formData.travelLinkman"
                  placeholder="请输入联系人"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="手机号:"
                prop="travelPhone"
              >
                <el-input
                  v-model="formData.travelPhone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱:">
                <el-input
                  v-model="formData.travelEmail"
                  placeholder="请输入电子邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人QQ:">
                <el-input
                  v-model="formData.travelQq"
                  placeholder="请输入联系人QQ"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-data-head">旅游资质</div>
          <div class="form-data-input">
            <el-form
              label-width="160px"
              :model="formData"
              ref="travelForm"
              :rules="rules"
            >
              <el-form-item
                label="旅游经营许可证:"
                prop="travelBusinessLicenseNum"
              >
                <el-input
                  v-model="formData.travelBusinessLicenseNum"
                  placeholder="请输入旅游经营许可证"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="旅游经营许可证照片:"
                prop="travelBusinessLicensePic"
              >
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :before-upload="detectionImg"
                  :http-request="(res) => uploadChange(res, 'travelBusinessLicensePic', 'travelForm')"
                  :file-list="fileListImg['travelBusinessLicensePic']"
                  accept="image/jpg, image/jpeg, image/x-png"
                  v-loading="uploadLoading['travelBusinessLicensePic']"
                >
                  <img
                    v-if="imageUrl['travelBusinessLicensePic']"
                    :src="imageUrl['travelBusinessLicensePic']"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  ></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="公章:">
                <div class="form-item-card">
                  <p class="form-item-card-title">请上传公章</p>
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :show-file-list="false"
                    :before-upload="detectionImg"
                    :http-request="(res) => uploadChange(res, 'commonSeal')"
                    :file-list="fileListImg['commonSeal']"
                    accept="image/jpg, image/jpeg, image/x-png"
                    v-loading="uploadLoading['commonSeal']"
                  >
                    <img
                      v-if="imageUrl['commonSeal']"
                      :src="imageUrl['commonSeal']"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    ></i>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="品牌名:">
                <el-input
                  v-model="formData.brandName"
                  placeholder="请输入品牌名"
                ></el-input>
              </el-form-item>
              <el-form-item label="品牌logo:">
                <div class="form-item-card">
                  <p class="form-item-card-title">请上传品牌logo</p>
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :show-file-list="false"
                    :before-upload="detectionImg"
                    :http-request="(res) => uploadChange(res, 'brandLogo')"
                    :file-list="fileListImg['brandLogo']"
                    accept="image/jpg, image/jpeg, image/x-png"
                    v-loading="uploadLoading['brandLogo']"
                  >
                    <img
                      v-if="imageUrl['brandLogo']"
                      :src="imageUrl['brandLogo']"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    ></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-form>
            <div class="form-data-submit">
              <div class="form-data-sub-box">
                <div class="form-data-sub-text flex-center-start">
                  <el-checkbox v-model="agreeStatu"></el-checkbox>
                  <span>
                    我已同意
                    <span
                      class="cursor"
                      style="color: #237dc8"
                      @click="protocolText.show = true"
                    >《{{ protocolText.title }}》</span>
                    <span
                      class="cursor"
                      style="color: #237dc8"
                      @click="protocolText.show1 = true"
                    >《{{ protocolText.title1 }}》</span>
                  </span>
                </div>
                <el-button
                  type="primary"
                  @click="submitForm"
                >立即提交</el-button>
              </div>
            </div>
          </div>
        </el-col>
      </div>
      <div class="form-data-text">
        <div class="text-box">
          <div class="form-data-head">合作流程</div>
          <ul>
            <li>第一步：注册账号</li>
            <li>第二步：后台人工审核</li>
            <li>第三步：签订合作协议</li>
            <li>第四步：完成开通</li>
          </ul>
        </div>
        <div>
          <div class="form-data-head">注册须知</div>
          <ul>
            <li style="font-weight: bold; color: red">
              1、平台账号必须“签约”后才能正常使用。
            </li>
            <li>2、提交注册申请前，请您提供真实有效的企业资质；</li>
            <li>
              3、在线提交注册申请时，请您根据提示说明认真填写，并与正本资料仔细核对，确保信息一致；
            </li>
            <li>
              4、平台哪些类型的产品可以合作？以下产品可以合作：跟团游，定制，度假，门票，酒店，机票，签证、租车及其他旅游相关服务；具体要以签约产品类型进行合作；
            </li>
            <li>
              5、我可以注册两个或两个以上的胤之旅账户吗？胤之旅的会员账户与手机绑定，一个手机只能注册一个账户并成为管理员。管理员可以添加不同的一个以上的子账户并可以为子账号分配权限；
            </li>
            <li>
              6、提交合作信息申请后胤之旅会在1-2个工作日内回复，请留意短信或邮箱信息。也可致电400-626-8448联系客服。
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog
      title="图片验证"
      :visible.sync="authCode.show"
      :close-on-click-modal="false"
      width="300px"
    >
      <div class="flex-center code-auth">
        <img
          :src="authCode.url"
          alt=""
        />
        <el-input
          v-model="authCode.value"
          ref="authCode"
          @keydown.enter.native="getPhoneAuthCode"
        ></el-input>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="getPhoneAuthCode"
          size="small"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="protocolText.show"
      width="800px"
    >
      <div
        v-html="protocolText.text"
        style="text-align: justify"
      ></div>
    </el-dialog>
    <el-dialog
      :visible.sync="protocolText.show1"
      width="800px"
    >
      <div
        v-html="protocolText.text1"
        style="text-align: justify"
      ></div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'underscore';

import register from "@/lib/data-service/default/web_common_userSupplier_register";
import getInlandAreaChildListByParentIdResponse from "@/lib/data-service/default/web_common_area_getInlandAreaChildListByParentIdResponse";
import kaptcha from "@/lib/data-service/default/web_common_kaptcha";
import phoneRegister from "@/lib/data-service/default/web_common_register";
import vueCheckUserName from "@/lib/data-service/default/web_common_user_vueCheckUserName";
import web_common_user_checkPhone from "@/lib/data-service/default/web_common_user_checkPhone";

import { STATUS } from "@/lib/deprecated/utils/status";
import get_url_prefix from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_url_prefix";
import liability from "@/page/distributor/other/aboutUs/text/liability";
import knowledge from "@/page/distributor/other/aboutUs/text/knowledge";

const SUCCESS_CODE = STATUS.success;
import OssClient from "yinzhilv-js-sdk/frontend/common-project/lib/system-docking/aliyun/oss/frontend/client";
import userSupplier_details from "@/lib/data-service/default/web_common_userSupplier_details";
import updateSupplier from "@/lib/data-service/default/web_common_userSupplier_updateSupplier";
import verification from "@/lib/deprecated/utils/verification/1.0.2";

export default {
  data() {
    return {
      formData: {
        applicationType: "1",
        userName: "",
        password: "",
        phone: "",
        smsCode: "",
        internationalWeek: [],
        domesticWorkday: [],
        domesticWorkWeek: [],
        internationalWorkday: [],
        airEmail: "",
        airLinkman: "",
        airPhone: "",
        airQq: "",
        areaCity: "",
        areaCityName: "",
        areaProvince: "",
        areaProvinceName: "",
        areaRegion: "",
        areaRegionName: "",
        brandLogo: "",
        brandName: "",
        businessLicenseNum: "",
        businessLicensePic: "",
        cataProve: "",
        commonSeal: "",
        companyAddress: "",
        companyId: 0,
        companyName: "",
        domesticWeekendEndTime: "",
        domesticWeekendStartTime: "",
        domesticWorkdayEndTime: "",
        domesticWorkdayStartTime: "",
        financeFax: "",
        guarantee: "",
        iataProve: "",
        idCard: "",
        idCardFront: "",
        idCardReverse: "",
        internationalWeekendEndTime: "",
        internationalWeekendStartTime: "",
        internationalWorkdayEndTime: "",
        internationalWorkdayStartTime: "",
        officeId: "",
        travelBusinessLicenseNum: "",
        travelBusinessLicensePic: "",
        travelEmail: "",
        travelLinkman: "",
        travelPhone: "",
        travelQq: "",
        areaCitys: [],
      },
      ossClient: new OssClient(),
      protocolText: {
        show: false,
        show1: false,
        text: liability,
        text1: knowledge,
        title: "网站声明",
        title1: "知识产权声明",
      },
      authCode: {
        url: "",
        value: "",
        show: false,
      }, //图片验证
      getCodePhone: {
        staut: false,
        show: false,
        num: 60,
        text: "获取短信验证码",
      }, //验证短信按钮
      siteList: {}, //地址
      agreeStatu: false,
      fileListImg: {
        businessLicensePic: [],
        idCardFront: [],
        idCardReverse: [],
        travelBusinessLicensePic: [],
        guarantee: [],
        brandLogo: [],
        cataProve: [],
        iataProve: [],
      },
      imageUrl: {
        businessLicensePic: '',
        idCardFront: '',
        idCardReverse: '',
        cataProve: '',
        iataProve: '',
        guarantee: '',
        travelBusinessLicensePic: '',
        commonSeal: '',
        brandLogo: '',
      },
      uploadLoading: {
        businessLicensePic: false,
        idCardFront: false,
        idCardReverse: false,
        cataProve: false,
        iataProve: false,
        guarantee: false,
        travelBusinessLicensePic: false,
        commonSeal: false,
        brandLogo: false,
      },
      selectCityStatu: false,
      rules: {
        //验证
        userName: [
          {
            validator: verification.checkUser,
            trigger: "blur",
            required: true,
          },
        ],
        password: [
          {
            validator: verification.checkPassWord,
            trigger: "blur",
            required: true,
          },
        ],
        passwordAgain: [
          {
            validator: verification.validatePass,
            trigger: "blur",
            required: true,
          },
        ],
        phone: [
          {
            validator: verification.checkPhone,
            trigger: "blur",
            required: true,
          },
        ],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        companyAddress: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
        ],
        businessLicenseNum: [
          {
            validator: verification.checkBusinessLicense,
            trigger: ["blur", "chang"],
            required: true,
          },
        ],
        businessLicensePic: [
          {
            validator: verification.checkBusinessLicensePic,
            required: true,
          },
        ],
        airLinkman: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        airPhone: [
          {
            validator: verification.checkPhone,
            trigger: "blur",
            required: true,
          },
        ],
        travelLinkman: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        travelPhone: [
          {
            validator: verification.checkPhone,
            trigger: "blur",
            required: true,
          },
        ],
        areaCitys: [
          { required: true, message: "请选择城市", trigger: ["blur", "chang"] },
        ],
        idCardReverse: [
          { validator: verification.checkIdCard, required: true },
        ],
        officeId: [
          { required: true, message: "请选择officeId", trigger: "blur" },
        ],
        guarantee: [{ required: true, validator: verification.checkGuarantee }],
        cataProve: [{ required: true, validator: verification.checkCataProve }],
        domesticWorkday: [
          {
            validator: verification.checkDomesticWorkday,
            required: true,
            trigger: "change",
          },
        ],
        travelBusinessLicenseNum: [
          {
            validator: verification.checkTravelBusinessLicense,
            required: true,
            trigger: "blur",
          },
        ],
        travelBusinessLicensePic: [
          {
            validator: verification.checkTravelBusinessLicensePic,
            required: true,
          },
        ],
        idCard: [
          { required: true, validator: verification.checkId, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    formData: {
      handler(newVal) {
        verification.formData = newVal;
      },
      deep: true,
    },
  },
  mounted() {
    this._getInlandArea("100000", (res) => {
      this.$set(this.siteList, "area", res);
    });
    verification.self = this;
    if (this.$route.query.type) {
      let id = this.$route.query.id;
      this.getInfo(id);
    }
  },
  methods: {
    getInfo(supplierId) {
      userSupplier_details({ supplierId }).then((res) => {
        let data = Object.assign(this.formData, res.result);
        let imgList = [
          "businessLicensePic",
          "idCardFront",
          "idCardReverse",
          "travelBusinessLicensePic",
          "guarantee",
          "brandLogo",
          "cataProve",
          "iataProve",
        ];
        imgList.map((name) => {
          if (data[name]) {
            this.fileListImg[name].push({
              name: name,
              url: data[name],
            });
            document.querySelector(`#${name} .el-upload`).style.display =
              "none";
          }
        });
        let timeList = [
          "internationalWeek",
          "internationalWorkday",
          "domesticWorkday",
          "domesticWorkWeek",
        ];

        if (
          data.internationalWorkdayStartTime &&
          data.internationalWorkdayEndTime
        ) {
          data.internationalWorkday = [
            data.internationalWorkdayStartTime,
            data.internationalWorkdayEndTime,
          ];
        }
        if (
          data.internationalWeekendStartTime &&
          data.internationalWeekendEndTime
        ) {
          data.internationalWeek = [
            data.internationalWeekendStartTime,
            data.internationalWeekendEndTime,
          ];
        }
        if (data.domesticWorkdayStartTime && data.domesticWorkdayEndTime) {
          data.domesticWorkday = [
            data.domesticWorkdayStartTime,
            data.domesticWorkdayEndTime,
          ];
        }
        if (data.domesticWeekendStartTime && data.domesticWeekendEndTime) {
          data.domesticWorkWeek = [
            data.domesticWeekendStartTime,
            data.domesticWeekendEndTime,
          ];
        }
        data.areaRegions = data.areaRegionName;
        data.areaProvinces = data.areaProvinceName;
        data.areaCitys = data.areaCityName;
        this.$nextTick(() => {
          this.formData = data;
        });
      });
    },
    //获取产品图片上传的地址
    uploadChange(file, name, from) {
      this.$set(this.uploadLoading, name, true);
      this.ossClient
        .multipartUpload({
          file: file.file,
        })
        .then((res) => {
          this.formData[name] = res.url;
          this.$set(this.imageUrl, name, res.url);
          this.$message({ type: "success", message: "上传图片成功" });
          this.checkUpload(name, from);
        })
        .catch(() => {
          this.$message.error('上传图片失败');
        })
        .finally(() => {
          this.$set(this.uploadLoading, name, false);
        });
    },
    checkUpload(name, from) {
      if (from) {
        name === "businessLicensePic"
          ? this.$refs[from].validateField("businessLicenseNum")
          : "";
        name === "idCardFront" || "idCardReverse"
          ? this.$refs[from].validateField("idCardReverse")
          : "";
        name === "cataProve" ? this.$refs[from].validateField("cataProve") : "";
        name === "guarantee" ? this.$refs[from].validateField("guarantee") : "";
        name === "travelBusinessLicensePic"
          ? this.$refs[from].validateField("travelBusinessLicenseNum")
          : "";
      }
    },

    //检验img格式
    detectionImg(file) {
      var reg2 = /^(\s|\S)+(jpg|png|bmp|jpeg)+$/;
      const isLt2M = file.size / 1024 < 10240;
      if (!reg2.test(file.name)) {
        this.$message({ type: "warning", message: "图片格式上传错误！" });
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10M!");
        return false;
      }
    },
    //处理产品图片的删除
    handleRemoveImg(file, name, from) {
      this.formData[name] = "";
      this.fileListImg[name] = [];
      this.checkUpload(name, from);
      document.querySelector(`#${name} .el-upload`).style.display = "block";
    },
    //检查用户名
    queryUserName() {
      const name = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
      if (!this.formData.userName) {
        return;
      } else {
        if (!name.test(this.formData.userName)) return;
      }
      vueCheckUserName({ userName: this.formData.userName }).then((res) => {
        if (res.code === SUCCESS_CODE) {
          !res.flag
            ? this.$message({ type: "warning", message: "用户已注册" })
            : "";
        }
      });
    },
    //获取短信
    getNote() {
      let phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (!this.formData.phone) {
        return this.$message({ type: "warning", message: "请输入手机号码" });
      } else {
        if (!phoneReg.test(this.formData.phone)) {
          return this.$message({
            type: "warning",
            message: "电话号码格式不正确",
          });
        }
      }
      this.authCode.value = "";
      this.authCode.show = true;
      kaptcha().then((res) => {
        if (res.code === SUCCESS_CODE) {
          this.authCode.url = res.img;
          this.authCode.uuid = res.uuid;
          this.$refs.authCode.focus();
        }
      });
    },
    //手机验证码
    getPhoneAuthCode() {
      let authCode = this.authCode;
      if (authCode.value) {
        authCode.show = false;
        let data = {
          phoneNumber: this.formData.phone,
          verificationCode: authCode.value,
          roleType: 2,
          uuid: authCode.uuid,
        };
        this.getCodePhone.statu = true;
        phoneRegister(data).then(
          (res) => {
            if (res.code === SUCCESS_CODE) {
              this.getCodePhone.statu = false;
              this.getCodePhone.show = true;
              this.getCodePhone.text = "重新发送";
              let codeNmu = setInterval(() => {
                this.getCodePhone.num--;
                if (this.getCodePhone.num < 1) {
                  clearInterval(codeNmu);
                  this.getCodePhone.text = "获取短信验证码";
                  this.getCodePhone.show = false;
                  this.getCodePhone.num = 60;
                }
              }, 1000);
            }
          },
          (error) => {
            this.getCodePhone.statu = false;
            this.$forceUpdate();
          }
        );
      }
    },
    //提交表单
    submitForm() {
      let data = this.formData;
      let formRuleName = [];
      let _this = this;

      this.formData.applicationType == "1"
        ? (formRuleName = ["userForm", "companyForm", "airForm", "airUserForm"])
        : this.formData.applicationType == "2"
        ? (formRuleName = [
            "userForm",
            "companyForm",
            "travelForm",
            "travelUserForm",
          ])
        : (formRuleName = [
            "userForm",
            "companyForm",
            "airForm",
            "travelForm",
            "airUserForm",
            "travelUserForm",
          ]);
      let statu = formRuleName.map((item) => {
        let _s = Boolean;
        this.$refs[item].validate((valid) => {
          if (valid) {
            _s = true;
            if (this.$route.query.type) {
              if (data.areaCitys && this.selectCityStatu) {
                data.areaRegion = data.areaRegions[0];
                data.areaProvince = data.areaProvinces[0];
                data.areaCity = data.areaCitys[0];
                data.areaRegionName = data.areaRegions[1];
                data.areaProvinceName = data.areaProvinces[1];
                data.areaCityName = data.areaCitys[1];
              }
            } else {
              if (data.areaCitys) {
                data.areaRegion = data.areaRegions[0];
                data.areaProvince = data.areaProvinces[0];
                data.areaCity = data.areaCitys[0];
                data.areaRegionName = data.areaRegions[1];
                data.areaProvinceName = data.areaProvinces[1];
                data.areaCityName = data.areaCitys[1];
              }
            }

            //机票出票时间
            data.domesticWorkday.length != 0
              ? ((data.domesticWorkdayStartTime = data.domesticWorkday[0]),
                (data.domesticWorkdayEndTime = data.domesticWorkday[1]))
              : "";
            data.domesticWorkWeek.length != 0
              ? ((data.domesticWeekendStartTime = data.domesticWorkWeek[0]),
                (data.domesticWeekendEndTime = data.domesticWorkWeek[1]))
              : "";

            data.internationalWorkday.length != 0
              ? ((data.internationalWorkdayStartTime =
                  data.internationalWorkday[0]),
                (data.internationalWorkdayEndTime =
                  data.internationalWorkday[1]))
              : "";
            data.internationalWeek.length != 0
              ? ((data.internationalWeekendStartTime =
                  data.internationalWeek[0]),
                (data.internationalWeekendEndTime = data.internationalWeek[1]))
              : "";
          } else {
            _s = false;
          }
        });
        return _s;
      });
      statu = statu.every((item) => item === true);
      if (statu) {
        if (!this.agreeStatu)
          return this.$message({
            type: "warning",
            message: "请勾选服务协议！",
          });
        data.idCard = data.idCard.replace(/\s+/g, "");
        data.businessLicenseNum = data.businessLicenseNum.replace(/\s+/g, "");
        this.$route.query.id ? (data.companyId = this.$route.query.id) : "";
        this.$route.query.type
          ? updateSupplier(data).then((res) => {
              _this.$router.push({
                name: "register-success",
                query: { type: "4" },
              });
            })
          : register(data).then((res) => {
              _this.$router.push({
                name: "register-success",
                query: { type: "4" },
              });
              // let url = get_url_prefix({environment: global.appConfig.environment, appKey: 'default'})
              // window.location.href = url
            });
      } else {
        this.$nextTick(() => {
          let firstEle = document.getElementsByClassName(
            "el-form-item__error"
          )[0];
          document.documentElement.scrollTop =
            document.documentElement.scrollTop +
            firstEle.getBoundingClientRect().top -
            firstEle.parentElement.offsetHeight -
            18;
        });
        return false;
      }

      if (data.applicationType == "1" || data.applicationType == "1+2") {
        if (
          data.domesticWorkday.length === 2 &&
          data.domesticWorkWeek.length === 2
        ) {
          for (let i = 0; i < data.domesticWorkday.length; i++) {
            if (!data.domesticWorkday[i]) {
              this.$message({ type: "warning", message: "请选择国内出票时间" });
              return;
            }
          }
          for (let i = 0; i < data.domesticWorkWeek.length; i++) {
            if (!data.domesticWorkWeek[i]) {
              this.$message({ type: "warning", message: "请选择国内出票时间" });
              return;
            }
          }
        } else {
          return this.$message({
            type: "warning",
            message: "请选择国内出票时间",
          });
        }
      }
    },
    //获取城市列表
    _getInlandArea(id, callback) {
      getInlandAreaChildListByParentIdResponse({ id: id }).then((res) => {
        callback(res.areaTreeResult);
      });
    },
    //选中大区
    _getArea(val) {
      this.selectCityStatu = true;
      this._getInlandArea(val[0], (res) => {
        this.formData.areaProvinces ? (this.formData.areaProvinces = "") : "";
        this.formData.areaCitys ? (this.formData.areaCitys = "") : "";
        this.$set(this.siteList, "province", res);
        this.$set(this.siteList, "city", []);
      });
    },
    //选中省份
    _getProvince(val) {
      this._getInlandArea(val[0], (res) => {
        this.formData.areaCitys ? (this.formData.areaCitys = "") : "";
        this.$nextTick(() => {
          this.$set(this.siteList, "city", res);
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.head-banner {
  width: 100%;
  height: 100px;
  background: url("//tour.yinzhilv.com/static/tour/img/vendorbreadcramps.png")
    no-repeat;
  background-size: cover;
  background-position: center right;
}
.code-auth {
  img {
    height: 35px;
    margin-right: 5px;
    border: 1px solid #ccc;
  }
  /deep/.el-input {
    input {
      height: 35px;
      border-radius: 0;
    }
  }
}
.ticket-time {
  margin-bottom: 10px;
  span {
    padding: 10px;
  }
}
.form-data-info {
  width: 70%;
  .form-data-input {
    padding: 30px 40px;
    margin-bottom: 20px;
    border: 1px solid #f3f3f3;
    font-size: 14px;
    color: #606266;
    .form-label {
      display: inline-block;
      width: 120px;
      text-align: right;
      padding-right: 12px;
    }
    /deep/.el-input {
      input {
        height: 35px;
        border-radius: 0;
      }
    }
  }
  .el-button {
    background: #237dc8;
  }
  .code-btn {
    width: 180px;
    background: #237dc8;
    color: white;
  }
  .form-data-submit {
    .form-data-sub-box {
      width: 68%;
      margin: auto;
      .form-data-sub-text {
        font-size: 14px;
        color: #606266;
        padding: 20px 0;
        span {
          padding-left: 10px;
        }
      }
    }
  }
  .form-item-card {
    margin-bottom: 10px;
    .form-item-card-title {
      background: #f2f2f2;
      color: #afafaf;
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
.el-button {
  border-radius: 0;
}
.form-data-head {
  height: 40px;
  line-height: 40px;
  color: #e5e5e5;
  background: #237dc8;
  padding-left: 30px;
}
.form-data-text {
  width: 28%;
  margin-left: 2%;
  .text-box {
    margin-bottom: 30px;
  }
  ul {
    padding: 30px;
    border: 1px solid #f3f3f3;
    li {
      list-style: none;
      font-size: 14px;
      color: #a8a8a8;
      padding: 13px 0;
      line-height: 22px;
      text-align: justify;
    }
  }
}
.content {
  display: flex;
  width: 1200px;
  margin: auto;
  margin-top: 30px;
}
.nav-btn {
  color: #666;
  font-size: 16px;
  display: flex;
  justify-content: center;
  div {
    display: flex;
    justify-content: center;
  }
  span {
    cursor: pointer;
    padding: 8px 30px;
    margin: 30px 10px;
    border: 1px solid #dfdfdf;
    &:hover {
      border-color: #237dc8;
      color: #237dc8;
    }
  }
}
.nav-active {
  color: #237dc8;
  border-color: #237dc8 !important;
}
.warning {
  width: 1200px;
  margin: auto;
  padding: 40px 0;
  font-size: 17px;
  color: #666;
  font-weight: bold;
  display: flex;
  align-items: center;
  i {
    font-size: 23px;
    color: red;
    margin-right: 10px;
  }
}
.body {
  .avatar-uploader {
    width: 180px;
  }
  /deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/.avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  /deep/.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  /deep/.avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
